import { Link } from "react-router-dom";
import HeroLive from "@/pages/home/components/HeroLive";
import NewsTicker from "@/pages/home/components/NewsTicker";
import LiveNow from "@/pages/home/components/LiveNow";
import SchedulePreview from "@/pages/home/components/SchedulePreview";
import NewsFeed from "@/pages/home/components/NewsFeed";
import FeaturedTeams from "@/pages/home/components/FeaturedTeams";
import SectionHeading from "@/components/feature/SectionHeading";

const services = [
  {
    icon: "ri-live-line",
    title: "实时直播入口",
    desc: "聚合欧冠赛事的直播观看入口，实时比分、赛事实况与比赛阶段一站掌握。",
  },
  {
    icon: "ri-calendar-2-line",
    title: "完整赛程查询",
    desc: "按赛季与日期筛选赛程，查看对阵、比分与比赛状态，不错过任何一场对决。",
  },
  {
    icon: "ri-shield-star-line",
    title: "球队资料库",
    desc: "球队历史、阵容名单、赛季统计与近期战绩，深入了解每支参赛球队。",
  },
  {
    icon: "ri-newspaper-line",
    title: "欧冠资讯中心",
    desc: "赛事战报、球队动态、转会消息与数据分析，多维度追踪欧冠最新动向。",
  },
];

export default function Home() {
  return (
    <div className="w-full">
      <HeroLive />
      <NewsTicker />
      <LiveNow />
      <SchedulePreview />
      <NewsFeed />

      <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
        <SectionHeading
          eyebrow="WHY US"
          title="一站式欧冠观赛体验"
          description="从直播入口到赛程、球队资料与资讯，欧冠直播为你把观赛需要的信息整理在一起。"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {services.map((s, index) => (
            <div
              key={s.title}
              className={`rounded-lg border p-5 md:p-6 ${
                index % 2 === 0
                  ? "border-background-200 bg-background-100"
                  : "border-primary-100 bg-primary-50/50"
              }`}
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-2xl">
                <i className={s.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 text-base md:text-lg font-semibold text-foreground-950">
                {s.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <FeaturedTeams />

      <section className="w-full px-4 md:px-6 pb-14 md:pb-20">
        <div className="relative w-full rounded-lg overflow-hidden bg-primary-950">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20empty%20football%20stadium%20at%20night%20with%20blue%20floodlights%20and%20dark%20atmospheric%20sky%2C%20minimal%20stylized%20sports%20background%2C%20cinematic%20mood%2C%20high%20contrast&width=1600&height=600&seq=ucl-home-cta-01&orientation=landscape"
            alt="欧冠直播观赛入口"
            title="欧冠直播 观赛入口"
            className="absolute inset-0 w-full h-full object-cover object-top opacity-45"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/75 to-primary-950/45"></div>
          <div className="relative px-5 md:px-10 py-10 md:py-16 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            <div className="max-w-2xl">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
                关注每一场欧冠对决
              </h2>
              <p className="mt-3 text-sm md:text-base text-background-200 leading-relaxed">
                订阅赛事资讯，赛前提醒、赛后战报与球队动态第一时间送达。你也可以通过留言表单告诉我们你的建议。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 shrink-0">
              <Link
                to="/news"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3 text-base font-semibold text-background-50 hover:bg-accent-600 transition-colors whitespace-nowrap"
              >
                浏览资讯
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-200/60 bg-white/10 px-6 py-3 text-base font-semibold text-background-50 hover:bg-white/20 transition-colors whitespace-nowrap"
              >
                联系我们
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}